const environment = "dev";

export default environment;
